/**
 * Structured legal-reference and evidence-requirement primitives. Plan §26.2.
 * Kaiyang Lesson §25.5: citations must be structured (instrument / article /
 * annex / ...), never opaque `string[]`. `EvidenceRequirement.sourceLegalReferenceIndex`
 * is the reverse pointer that lets evidence trace back to a specific citation.
 */

import { z } from "zod";
import { CitationGranularity } from "./primitives";

export const LegalReferenceSchema = z.object({
  instrument: z.string().min(1),
  article: z.string().optional(),
  annex: z.string().optional(),
  section: z.string().optional(),
  paragraph: z.string().optional(),
  uri: z.string().url().optional(),
  granularity: CitationGranularity,
  confidence: z.number().int().min(0).max(100),
  citationGapReason: z.string().optional(),
});
export type LegalReference = z.infer<typeof LegalReferenceSchema>;

export const EvidenceRequirementSchema = z.object({
  description: z.string().min(1),
  artifactKind: z.string().optional(),
  sourceLegalReferenceIndex: z.number().int().nonnegative().optional(),
  standardReference: z.string().optional(),
});
export type EvidenceRequirement = z.infer<typeof EvidenceRequirementSchema>;
